import VideoCallBookingHeader from './VideoCallBookingHeader'

export default VideoCallBookingHeader
